import"../../../node_modules/.pnpm/@lit_reactive-element@2.1.0/node_modules/@lit/reactive-element/reactive-element.js";import{html as L}from"../../../node_modules/.pnpm/lit-html@3.3.0/node_modules/lit-html/lit-html.js";import"../../../node_modules/.pnpm/lit-element@4.2.0/node_modules/lit-element/lit-element.js";import{icon as t}from"../../icon-registry.js";const o=t("jordan",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <path
                d="M0 4.5L24 4.5L24 20.5L0 20.5L0 4.5Z"
                fill="white" />
            <path
                d="M0 4.5L24 4.5V9.83332L0 9.83332L0 4.5Z"
                fill="black" />
            <path
                d="M0 15.167L24 15.167V20.5003L0 20.5003L0 15.167Z"
                fill="#007A3D" />
            <path
                d="M12 12.5L0 20.5L0 4.5M5.41428 11.3571L5.04285 11.9857L4.07617 11.7889L4.58096 12.373L3.74289 12.7539L4.74766 12.8555L4.67148 13.5286L5.41434 13.0714L6.16193 13.5286L6.08576 12.8555L7.08578 12.7539L6.25246 12.373L6.75725 11.7889L5.79057 11.9857L5.41428 11.3571Z"
                fill="#CE1126" />
        </svg>
    `),p=t("jordan_rounded",L`
        <svg
            width="24"
            height="25"
            viewBox="0 0 24 25"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
            static>
            <g clip-path="url(#clip0_19470_85959)">
                <rect
                    y="0.5"
                    width="24"
                    height="24"
                    rx="12"
                    fill="#FF4E4E" />
                <path
                    d="M0 0.5L24 0.5L24 24.5L0 24.5L0 0.5Z"
                    fill="white" />
                <path
                    d="M0 0.5L24 0.5V8.49998L0 8.49998L0 0.5Z"
                    fill="black" />
                <path
                    d="M0 16.5L24 16.5V24.5L0 24.5L0 16.5Z"
                    fill="#007A3D" />
                <path
                    d="M12 12.5L0 24.5L0 0.5M5.41428 10.7857L5.04285 11.7286L4.07617 11.4333L4.58096 12.3095L3.74289 12.8809L4.74766 13.0333L4.67148 14.0428L5.41434 13.3571L6.16193 14.0428L6.08576 13.0333L7.08578 12.8809L6.25246 12.3095L6.75725 11.4333L5.79057 11.7286L5.41428 10.7857Z"
                    fill="#CE1126" />
            </g>
            <defs>
                <clipPath id="clip0_19470_85959">
                    <rect
                        y="0.5"
                        width="24"
                        height="24"
                        rx="12"
                        fill="white" />
                </clipPath>
            </defs>
        </svg>
    `);export{o as Jordan,p as JordanRounded};
